import { Typography } from "@mui/material";

export const HeadingTitle = ({ text }) => {
  return (
    <Typography
      variant="h3"
      component="h4"
      color="green"
      fontWeight={"500"}
      style={{ marginBottom: "30px" }}
    >
      {text}
    </Typography>
  );
};
